// Stored sign-in session (task 175) — so a business owner/waiter signs once per session lifetime, not on
// every reload. Keyed by wallet address: a session only ever applies to the wallet that signed for it
// (and local dev tabs acting as different identities never share one). Storage may be blocked → no-op.

const KEY_PREFIX = 'chainsale.auth.';

export const storedSessionKey = (address: string): string => KEY_PREFIX + address.toLowerCase();

export const readStoredSession = (address: string): string | null => {
  try { return localStorage.getItem(storedSessionKey(address)); } catch { return null; }
};

export const writeStoredSession = (address: string, sessionId: string | null): void => {
  try {
    if (sessionId === null) localStorage.removeItem(storedSessionKey(address));
    else localStorage.setItem(storedSessionKey(address), sessionId);
  } catch { /* storage blocked — the session lasts until reload */ }
};
